/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDetailsResponse } from '../../models/user-details-response';
import { UserUpdateProfileRequest } from '../../models/user-update-profile-request';

export interface UpdateMyUserDetails$Params {
      body: UserUpdateProfileRequest
}

export function updateMyUserDetails(http: HttpClient, rootUrl: string, params: UpdateMyUserDetails$Params, context?: HttpContext): Observable<StrictHttpResponse<UserDetailsResponse>> {
  const rb = new RequestBuilder(rootUrl, updateMyUserDetails.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDetailsResponse>;
    })
  );
}

updateMyUserDetails.PATH = '/api/my/user-details';
